// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"405":"59d7b7afc8db5595","732":"1fcbeea548934d4e","953":"21ccba6d37d4aca9"}[chunkId] + ".css";
};